import { BaseMapper } from '@ps/utils';
import { SurveyQuestion } from '@ps/survey-utils';

import { GetAdvancedTargetingQuestionDto } from '../dtos/survey-question.dto';
import { SurveyCategoryMapper } from './survey-category.mapper';

export class SurveyQuestionMapper extends BaseMapper<
  GetAdvancedTargetingQuestionDto,
  SurveyQuestion
> {
  private readonly _categoryMapper = new SurveyCategoryMapper();

  // Questions without a qualification_id all map to an empty attributeId, and callers
  // match a selection by attributeId — so every malformed row would collide on one id.
  public override fromDtoList(
    dtos: GetAdvancedTargetingQuestionDto[],
  ): SurveyQuestion[] {
    return dtos
      .filter((dto) => Boolean(dto.qualification_id?.length))
      .map((dto) => this.fromDto(dto));
  }

  public fromDto(dto: GetAdvancedTargetingQuestionDto): SurveyQuestion {
    const attributeId = String(dto.qualification_id?.[0] ?? '');

    return {
      attributeId,
      desc: dto.question_description,
      category: this._categoryMapper.fromDtoList(dto.question_category ?? []),
      options: [...(dto.answers?.[attributeId]?.answer_data ?? [])]
        .sort((first, second) => first.sortId - second.sortId)
        .map((answer) => ({ id: String(answer.id), text: answer.text })),
      buyerText: dto.buyer_text,
    };
  }
}
